module.exports = __webpack_public_path__ + "img/kerning.59f26aa9.svg";